"use strict";
exports.__esModule = true;
exports.multipleCardsContainer = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var fields_1 = require("../../../fields");
var multipleCardsContainer = function (data, logger) {
    var _a, _b;
    return utils_1.compact({
        type: types_1.FooterCardType.MULTIPLE,
        imageTitle: fields_1.toImage((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.image_title, logger),
        textTitle: fields_1.toText((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.text_title),
        tiles: data === null || data === void 0 ? void 0 : data.items.map(function (item) {
            return utils_1.compact({
                image: logger.required(fields_1.toImage(item === null || item === void 0 ? void 0 : item.image, logger)),
                ctaLabel: logger.required(fields_1.toText(item === null || item === void 0 ? void 0 : item.ctaLabel)),
                ctaLink: logger.required(fields_1.toLink(item === null || item === void 0 ? void 0 : item.ctaLink, logger))
            });
        })
    });
};
exports.multipleCardsContainer = multipleCardsContainer;
//# sourceMappingURL=footer-multiple-card.js.map